// extracted by mini-css-extract-plugin
export default {"main":"privacy_main__K1Mic"};